import { styled } from '../theme'

export const NoSearchIcon = styled.div`
  .ant-input-group-addon {
    display: none;
  }
`
